import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-adb2ab6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tamanho-completo" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "ss-grade-personalizada-titulo" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Detalhes")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-linha" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Variação")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-linha" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-24" }, [
      /*#__PURE__*/_createElementVNode("span", null, "Imprimir na Venda/NF-e")
    ])
  ])
], -1))
const _hoisted_8 = { class: "ss-grade-personalizada-titulo" }
const _hoisted_9 = { class: "ss-titulo-campo" }
const _hoisted_10 = { class: "ant-row ss-grade-personalizada-linha" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_12 = {
  key: 0,
  class: "ss-margin-campos"
}
const _hoisted_13 = ["onUpdate:modelValue"]
const _hoisted_14 = {
  key: 1,
  class: "ss-margin-campos"
}
const _hoisted_15 = ["value", "onChange"]
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { class: "ant-row ss-grade-personalizada-linha" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_produto_codigos = _resolveComponent("produto-codigos")!
  const _component_produto_custos = _resolveComponent("produto-custos")!
  const _component_produto_precos = _resolveComponent("produto-precos")!
  const _component_card = _resolveComponent("card")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_produto_estoque = _resolveComponent("produto-estoque")!
  const _component_produto_unidades = _resolveComponent("produto-unidades")!
  const _component_produto_peso_medidas = _resolveComponent("produto-peso-medidas")!
  const _component_produto_fornecedores = _resolveComponent("produto-fornecedores")!
  const _component_produto_imagens = _resolveComponent("produto-imagens")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "100%",
      "wrap-class-name": "full-modal ss-modal-cadastros",
      visible: _ctx.state.apresentarModalVariacao,
      "onUpdate:visible": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.apresentarModalVariacao) = $event)),
      title: 'Variação do produto: ' + _ctx.props.descricaoProduto
    }, {
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-secondary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.apresentarModalVariacao = false))
          }, _hoisted_3),
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.confirmarDadosVariacao()))
          }, _hoisted_5)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, { loading: false }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _hoisted_7,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.produtoDefinicao.caracteristicasVariacao, (caracteristicaVariacao, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: "ant-col ant-col-xs-24 ant-col-xl-3"
                    }, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.obtemDescricaoCaracteristica(caracteristicaVariacao.codigoCaracteristica)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (caracteristicaVariacao.tipo === _ctx.ETipoCaracteristica.TextoLivre)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  class: "ant-input",
                                  maxlength: "250",
                                  "onUpdate:modelValue": ($event: any) => ((caracteristicaVariacao.caracteristicaPersonalizada) = $event)
                                }, null, 8, _hoisted_13), [
                                  [_vModelText, caracteristicaVariacao.caracteristicaPersonalizada]
                                ])
                              ]))
                            : (caracteristicaVariacao.tipo === _ctx.ETipoCaracteristica.Numero || caracteristicaVariacao.tipo === _ctx.ETipoCaracteristica.Decimal)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                  _createElementVNode("input", {
                                    type: "number",
                                    class: "ant-input",
                                    value: Number(caracteristicaVariacao.caracteristicaPersonalizada),
                                    onChange: ($event: any) => (caracteristicaVariacao.caracteristicaPersonalizada = String($event))
                                  }, null, 40, _hoisted_15)
                                ]))
                              : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.obtemValorCaracteristica(caracteristicaVariacao)), 1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_a_checkbox, {
                            checked: caracteristicaVariacao.imprimirVendaNfe,
                            "onUpdate:checked": ($event: any) => ((caracteristicaVariacao.imprimirVendaNfe) = $event)
                          }, null, 8, ["checked", "onUpdate:checked"])
                        ])
                      ])
                    ]))
                  }), 128))
                ]),
                _createVNode(_component_produto_codigos, {
                  codigoInterno: _ctx.state.produtoDefinicao.codigoInterno,
                  "onUpdate:codigoInterno": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.produtoDefinicao.codigoInterno) = $event)),
                  codigos: _ctx.state.produtoDefinicao.codigos,
                  "onUpdate:codigos": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.produtoDefinicao.codigos) = $event))
                }, null, 8, ["codigoInterno", "codigos"]),
                _createVNode(_component_a_tabs, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "1",
                      tab: "CUSTOS E PREÇOS"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, { titulo: " " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_produto_custos, {
                              empresas: _ctx.props.empresas,
                              codigoProdutoDefinicao: _ctx.state.produtoDefinicao.codigo,
                              custos: _ctx.state.produtoDefinicao.custos,
                              "onUpdate:custos": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.produtoDefinicao.custos) = $event))
                            }, null, 8, ["empresas", "codigoProdutoDefinicao", "custos"]),
                            _createVNode(_component_produto_precos, {
                              empresas: _ctx.props.empresas,
                              custos: _ctx.state.produtoDefinicao.custos,
                              codigoProdutoDefinicao: _ctx.state.produtoDefinicao.codigo,
                              precos: _ctx.state.produtoDefinicao.precos,
                              "onUpdate:precos": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.produtoDefinicao.precos) = $event))
                            }, null, 8, ["empresas", "custos", "codigoProdutoDefinicao", "precos"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "2",
                      tab: "ESTOQUE"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_produto_estoque, {
                          empresas: _ctx.props.empresas,
                          tipoRastreabilidade: _ctx.state.produtoDefinicao.tipoRastreabilidade,
                          "onUpdate:tipoRastreabilidade": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.produtoDefinicao.tipoRastreabilidade) = $event)),
                          tipoLancamentoRastreabilidade: _ctx.state.produtoDefinicao.tipoLancamentoRastreabilidade,
                          "onUpdate:tipoLancamentoRastreabilidade": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.produtoDefinicao.tipoLancamentoRastreabilidade) = $event)),
                          pontoPedido: _ctx.state.produtoDefinicao.pontoPedido,
                          "onUpdate:pontoPedido": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.produtoDefinicao.pontoPedido) = $event)),
                          tempoReposicao: _ctx.state.produtoDefinicao.tempoReposicao,
                          "onUpdate:tempoReposicao": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.produtoDefinicao.tempoReposicao) = $event)),
                          bloquearNovasCompras: _ctx.state.produtoDefinicao.bloquearNovasCompras,
                          "onUpdate:bloquearNovasCompras": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.produtoDefinicao.bloquearNovasCompras) = $event))
                        }, null, 8, ["empresas", "tipoRastreabilidade", "tipoLancamentoRastreabilidade", "pontoPedido", "tempoReposicao", "bloquearNovasCompras"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "3",
                      tab: "UNIDADES"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, { titulo: " " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_produto_unidades, {
                              empresas: _ctx.props.empresas,
                              codigoUnidadePrincipal: _ctx.props.codigoUnidadePrincipal,
                              fatorUnidadePrincipal: _ctx.props.fatorUnidadePrincipal,
                              "onUpdate:fatorUnidadePrincipal": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.props.fatorUnidadePrincipal) = $event)),
                              unidades: _ctx.state.produtoDefinicao.unidades,
                              "onUpdate:unidades": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.produtoDefinicao.unidades) = $event)),
                              codigos: _ctx.state.produtoDefinicao.codigos,
                              "onUpdate:codigos": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.produtoDefinicao.codigos) = $event))
                            }, null, 8, ["empresas", "codigoUnidadePrincipal", "fatorUnidadePrincipal", "unidades", "codigos"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "4",
                      tab: "PESO E MEDIDAS"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, { titulo: " " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_produto_peso_medidas, {
                              pesoEmbalagem: _ctx.state.produtoDefinicao.pesoEmbalagem,
                              "onUpdate:pesoEmbalagem": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.produtoDefinicao.pesoEmbalagem) = $event)),
                              pesoBruto: _ctx.state.produtoDefinicao.pesoBruto,
                              "onUpdate:pesoBruto": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.produtoDefinicao.pesoBruto) = $event)),
                              pesoLiquido: _ctx.state.produtoDefinicao.pesoLiquido,
                              "onUpdate:pesoLiquido": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.produtoDefinicao.pesoLiquido) = $event)),
                              comprimento: _ctx.state.produtoDefinicao.comprimento,
                              "onUpdate:comprimento": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.produtoDefinicao.comprimento) = $event)),
                              altura: _ctx.state.produtoDefinicao.altura,
                              "onUpdate:altura": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.produtoDefinicao.altura) = $event)),
                              largura: _ctx.state.produtoDefinicao.largura,
                              "onUpdate:largura": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.produtoDefinicao.largura) = $event))
                            }, null, 8, ["pesoEmbalagem", "pesoBruto", "pesoLiquido", "comprimento", "altura", "largura"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "5",
                      tab: "FORNECEDORES"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, { titulo: " " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_produto_fornecedores, {
                              empresas: _ctx.props.empresas,
                              fornecedores: _ctx.state.produtoDefinicao.fornecedores,
                              "onUpdate:fornecedores": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.produtoDefinicao.fornecedores) = $event))
                            }, null, 8, ["empresas", "fornecedores"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "6",
                      tab: "IMAGENS"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, { titulo: " " }, {
                          default: _withCtx(() => [
                            _createVNode(_component_produto_imagens, {
                              empresas: _ctx.props.empresas,
                              imagens: _ctx.state.produtoDefinicao.imagens,
                              "onUpdate:imagens": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.produtoDefinicao.imagens) = $event))
                            }, null, 8, ["empresas", "imagens"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}